import { useQuery } from '@tanstack/react-query';
import { fetchShipmentFieldsVisibility } from '../data-provider/shipment-fields-visibility';

export const useGetShipmentFieldsVisibility = (customerKey: number) => {
  return useQuery({
    queryKey: ['shipment-fields-visibility', customerKey],
    queryFn: () => fetchShipmentFieldsVisibility(),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 3, // 3 minutes
    enabled: Boolean(customerKey),
  });
};
